var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c("div", { staticClass: "single container-max page-content mb-4" }, [
            _c("div", { staticClass: "row position-relative" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md-6 mt-md-5 px-0 px-md-3" },
                [
                  _vm._t("image-carousel"),
                  _vm._v(" "),
                  _vm.savingMoneyPercent > 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "fs-saving bg-danger text-white border-radius p-2 d-inline position-absolute"
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "-" +
                                _vm._s(Math.floor(_vm.savingMoneyPercent)) +
                                "%"
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVariation.variationProperties &&
                  _vm.currentVariation.variationProperties.length > 0
                    ? [
                        _vm._l(
                          _vm.currentVariation.variationProperties,
                          function(variationPropertyGroups, index) {
                            return variationPropertyGroups.id === 35
                              ? [
                                  _c("button", {
                                    staticClass:
                                      "btn btn-primary fs-video-btn border-radius font-weight-bold d-flex align-items-center",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "modal",
                                      "data-target": "#product-video"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "ohrensessel::SingleItem.ModalButtonText"
                                        )
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "modal fade",
                                      attrs: {
                                        id: "product-video",
                                        tabindex: "-1",
                                        role: "dialog",
                                        "aria-labelledby": "product-video",
                                        "aria-hidden": "true"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "modal-dialog",
                                          attrs: { role: "document" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "modal-content" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "modal-header" },
                                                [
                                                  _c("h5", {
                                                    staticClass: "modal-title",
                                                    attrs: {
                                                      id: "product-video-label"
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$translate(
                                                          "ohrensessel::SingleItem.ModalHeadline"
                                                        )
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _vm._m(0, true)
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "modal-body" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "container-max px-0"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _vm._l(
                                                            variationPropertyGroups.properties,
                                                            function(
                                                              variationProperty
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-12 col-md-6 mb-3"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "video",
                                                                      {
                                                                        attrs: {
                                                                          controls:
                                                                            "",
                                                                          poster: _vm.$translate(
                                                                            "ohrensessel::SingleItem.ModalDefaulImage"
                                                                          )
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "source",
                                                                          {
                                                                            attrs: {
                                                                              src:
                                                                                variationProperty
                                                                                  .values
                                                                                  .value,
                                                                              type:
                                                                                "video/mp4"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "modal-footer" },
                                                [
                                                  _c("button", {
                                                    staticClass:
                                                      "btn btn-secondary",
                                                    attrs: {
                                                      type: "button",
                                                      "data-dismiss": "modal"
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$translate(
                                                          "ohrensessel::SingleItem.ModalClose"
                                                        )
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e()
                          }
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-6 mt-md-5 px-0 px-md-3" },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "h1",
                        {
                          staticClass:
                            "h4 title font-weight-bold mt-3 mt-lg-1 mb-3 mb-lg-4 px-3 px-md-0 head-font",
                          attrs: { "data-testing": "item-name" }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("itemName")(_vm.currentVariation))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buy-box pt-4 p-3 border-radius mb-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "single-usp d-flex w-100 justify-content-between align-items-center"
                            },
                            [
                              _c("ul", { staticClass: "list-unstyled m-0" }, [
                                _c("li", [
                                  _c("span", {
                                    staticClass: "font-weight-bold text-center",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "ohrensessel::SingleItem.Usp1"
                                        )
                                      )
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("span", {
                                    staticClass: "font-weight-bold text-center",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "ohrensessel::SingleItem.Usp2"
                                        )
                                      )
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("span", {
                                    staticClass: "font-weight-bold text-center",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "ohrensessel::SingleItem.Usp3"
                                        )
                                      )
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _vm.$translate("ohrensessel::SingleItem.Usp4")
                                  ? _c("li", [
                                      _c("span", {
                                        staticClass:
                                          "font-weight-bold text-center",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::SingleItem.Usp4"
                                            )
                                          )
                                        }
                                      })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$translate("ohrensessel::SingleItem.Usp5")
                                  ? _c("li", [
                                      _c("span", {
                                        staticClass:
                                          "font-weight-bold text-center",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::SingleItem.Usp5"
                                            )
                                          )
                                        }
                                      })
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.attributes.length || Object.keys(_vm.units).length
                            ? _c(
                                "div",
                                { staticClass: "mt-3" },
                                [_c("variation-select")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.variation.bundleType === "bundle"
                            ? _c("item-bundle", {
                                attrs: {
                                  "bundle-type":
                                    _vm.currentVariation.variation.bundleType,
                                  "bundle-components":
                                    _vm.currentVariation.bundleComponents
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("before-price"),
                          _vm._v(" "),
                          _vm.currentVariation.filter.isSalable &&
                          _vm.variationGroupedProperties.length
                            ? _c("div", [_c("order-property-list")], 1)
                            : _vm._e(),
                          _vm._v(" "),
                          _c("graduated-prices"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex w-100 justify-content-between align-items-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fs-availability d-flex flex-wrap align-items-center"
                                },
                                [
                                  _vm.currentVariation.variation.availability
                                    .id == 1
                                    ? _c("span", {
                                        staticClass:
                                          "mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-1",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::ItemAvailability.Availability1"
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.availability
                                    .id == 2
                                    ? _c("span", {
                                        staticClass:
                                          "mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-2",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::ItemAvailability.Availability2"
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.availability
                                    .id == 3
                                    ? _c("span", {
                                        staticClass:
                                          "mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-3",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::ItemAvailability.Availability3"
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.availability
                                    .id == 4
                                    ? _c("span", {
                                        staticClass:
                                          "mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-4",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::ItemAvailability.Availability4"
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.availability
                                    .id == 5
                                    ? _c("span", {
                                        staticClass:
                                          "mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-5",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::ItemAvailability.Availability5"
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.availability
                                    .id == 6
                                    ? _c("span", {
                                        staticClass:
                                          "mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-6",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::ItemAvailability.Availability6"
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.availability
                                    .id == 7
                                    ? _c("span", {
                                        staticClass:
                                          "mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-7",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::ItemAvailability.Availability7"
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.availability
                                    .id == 8
                                    ? _c("span", {
                                        staticClass:
                                          "mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-8",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::ItemAvailability.Availability8"
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.availability
                                    .id == 9
                                    ? _c("span", {
                                        staticClass:
                                          "mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-9 text-dark",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::ItemAvailability.Availability9"
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.availability
                                    .id == 10
                                    ? _c("span", {
                                        staticClass:
                                          "mb-md-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small availability-10 text-dark",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::ItemAvailability.Availability10"
                                            )
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("item-availability")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fs-price text-right d-flex flex-column justify-content-end align-items-end"
                                },
                                [
                                  _c("item-price", {
                                    attrs: {
                                      "show-cross-price":
                                        _vm.isRecommendedPriceActive
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "vat small text-muted",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "ohrensessel::SingleItem.Vat"
                                        )
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._t("after-price"),
                          _vm._v(" "),
                          _c("div", { staticClass: "fs-button" }, [
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [_vm._t("before-add-to-basket")],
                              2
                            ),
                            _vm._v(" "),
                            _vm.currentVariation.item.itemType === "set"
                              ? _c(
                                  "div",
                                  { staticClass: "alert alert-info w-100" },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemSetInfo"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "col-12 my-3 px-0" },
                                  [
                                    _c("add-to-basket", {
                                      attrs: {
                                        "variation-id":
                                          _vm.currentVariation.variation.id,
                                        "is-salable":
                                          !!_vm.currentVariation.filter &&
                                          _vm.currentVariation.filter.isSalable,
                                        "has-children":
                                          !!_vm.currentVariation.filter &&
                                          _vm.currentVariation.filter
                                            .hasActiveChildren,
                                        "interval-quantity":
                                          _vm.currentVariation.variation
                                            .intervalOrderQuantity || 1,
                                        "minimum-quantity":
                                          _vm.currentVariation.variation
                                            .minimumOrderQuantity,
                                        "maximum-quantity":
                                          !!_vm.currentVariation.variation
                                            .maximumOrderQuantity &&
                                          _vm.currentVariation.variation
                                            .maximumOrderQuantity > 0
                                            ? _vm.currentVariation.variation
                                                .maximumOrderQuantity
                                            : null,
                                        "order-properties": _vm.currentVariation.properties.filter(
                                          function(prop) {
                                            return prop.property.isOderProperty
                                          }
                                        ),
                                        "has-order-properties":
                                          _vm.currentVariation
                                            .hasOrderProperties,
                                        "has-required-order-property":
                                          _vm.currentVariation
                                            .hasRequiredOrderProperty,
                                        "use-large-scale": false,
                                        "show-quantity": true,
                                        "item-url": _vm._f("itemURL")(
                                          _vm.currentVariation
                                        ),
                                        "is-variation-selected":
                                          _vm.isVariationSelected &&
                                          _vm.currentVariation.filter.isSalable,
                                        "has-price": _vm._f(
                                          "hasItemDefaultPrice"
                                        )(_vm.currentVariation)
                                      }
                                    })
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [_vm._t("after-add-to-basket")],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _vm._t("additional-content-after-add-to-basket"),
                          _vm._v(" "),
                          _vm._t("additional-content-after-vat")
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mb-5" },
                        [
                          _c("easycredit-widget", {
                            attrs: {
                              "webshop-id": "1.de.12094.2",
                              amount:
                                _vm.currentVariation.prices.default.price.value,
                              extended: "true",
                              "disable-flexprice": "false"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.currentVariation.variationProperties &&
                      _vm.currentVariation.variationProperties.length > 0
                        ? [
                            _vm._l(
                              _vm.currentVariation.variationProperties,
                              function(variationPropertyGroups, index) {
                                return variationPropertyGroups.id === 8
                                  ? [
                                      _c("p", {
                                        staticClass:
                                          "h4 font-weight-bold mb-3 px-3 px-md-0",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$translate(
                                              "ohrensessel::SingleItem.KeyFactsHeadline"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "list-unstyled m-0 p-0 px-3 px-md-0"
                                        },
                                        [
                                          _vm._l(
                                            variationPropertyGroups.properties,
                                            function(variationProperty, index) {
                                              return [
                                                _c(
                                                  "li",
                                                  {
                                                    staticClass: "d-flex mb-3"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-check mr-3 mt-1"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "font-weight-bold",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          variationProperty
                                                            .values.value
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  : _vm._e()
                              }
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.currentVariation.barcodes, function(barcodes) {
                        return barcodes.name == "EAN"
                          ? [
                              _c("p", { staticClass: "ml-3 ml-md-0 mb-0" }, [
                                _c("span", [_vm._v("EAN: ")]),
                                _vm._v(_vm._s(barcodes.code))
                              ])
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm.currentVariation.variation.number != ""
                        ? [
                            _c("p", { staticClass: "ml-3 ml-md-0 mb-0" }, [
                              _c("span", [_vm._v("SKU: ")]),
                              _vm._v(
                                _vm._s(_vm.currentVariation.variation.number)
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "single container-fluid bg-primary pt-3",
              attrs: { id: "itemnav" }
            },
            [
              _c(
                "div",
                { staticClass: "container-max p-0 position-relative" },
                [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "single-nav list-unstyled d-flex justify-content-around m-2"
                    },
                    [_vm._t("single-navigation")],
                    2
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "single container-max page-content addinfo mt-md-5 mb-3"
            },
            [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-lg-6 order-2 order-lg-1 d-flex flex-wrap align-self-start"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "order-1 order-lg-1 w-100" },
                      [
                        _c("p", {
                          staticClass: "m-0",
                          attrs: { id: "itemDesc" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "item-description-container mb-45" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item-description",
                                class: {
                                  "item-collapse": _vm.descriptionLength > 850
                                }
                              },
                              [
                                _c("div", {
                                  ref: "itemDescription",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.description
                                    )
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.descriptionLength > 850
                              ? _c(
                                  "div",
                                  { attrs: { id: "descriptionToggle" } },
                                  [_vm._m(1)]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        [
                          _vm.hasVariationProperties
                            ? _c(
                                "div",
                                _vm._l(
                                  _vm.filteredVariationPropertyGroups,
                                  function(variationPropertyGroups, index) {
                                    return _c(
                                      "div",
                                      { key: index },
                                      [
                                        _c("p", {
                                          staticClass: "m-0",
                                          attrs: { id: "montage" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          variationPropertyGroups.properties,
                                          function(
                                            variationProperty,
                                            subIndex
                                          ) {
                                            return variationProperty.id === 239
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: subIndex,
                                                    staticClass:
                                                      "fs-montage bg-gray p-3 mb-45 border-radius"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "h4 font-weight-bold mb-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$translate(
                                                              "ohrensessel::SingleItem.NavigationMontage"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          variationProperty
                                                            .values.value
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e()
                        ],
                        _vm._v(" "),
                        [
                          _vm.hasVariationProperties
                            ? _c(
                                "div",
                                _vm._l(
                                  _vm.filteredVariationPropertyGroups,
                                  function(variationPropertyGroups, index) {
                                    return _c(
                                      "div",
                                      { key: index },
                                      [
                                        _c("p", {
                                          staticClass: "m-0",
                                          attrs: { id: "faq" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          variationPropertyGroups.properties,
                                          function(
                                            variationProperty,
                                            subIndex
                                          ) {
                                            return variationProperty.id === 240
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: subIndex,
                                                    staticClass:
                                                      "fs-faq bg-gray p-3 mb-45 border-radius"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "h4 font-weight-bold mb-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$translate(
                                                              "ohrensessel::SingleItem.NavigationFAQ"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          variationProperty
                                                            .values.value
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e()
                        ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-2 order-lg-2 w-100" }, [
                      _c(
                        "div",
                        {
                          staticClass: "bg-gray p-3 mb-45 border-radius",
                          attrs: { id: "techData" }
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "h4 font-weight-bold mb-3 mb-md-0" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemTechnicalData"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "mt-3",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.technicalData
                              )
                            }
                          })
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-lg-6 order-1 order-lg-2 px-0 px-lg-3"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "fs-xselling" },
                      [_vm._t("cross-selling-similar")],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "fs-xselling" },
                      [_vm._t("cross-selling-accessory")],
                      2
                    ),
                    _vm._v(" "),
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "fs-manufacturer bg-gray p-3 mb-45 border-radius"
                        },
                        [
                          _vm.hasVariationProperties
                            ? _c(
                                "div",
                                _vm._l(
                                  _vm.filteredVariationPropertyGroups,
                                  function(variationPropertyGroups, index) {
                                    return _c(
                                      "div",
                                      { key: index },
                                      [
                                        _c("p", {
                                          staticClass: "m-0",
                                          attrs: { id: "manufacturer" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          variationPropertyGroups.properties,
                                          function(
                                            variationProperty,
                                            subIndex
                                          ) {
                                            return variationProperty.id === 238
                                              ? _c("div", { key: subIndex }, [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "h4 font-weight-bold mb-3"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "ohrensessel::SingleItem.NavigationManufacturer"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        variationProperty.values
                                                          .value
                                                      )
                                                    }
                                                  })
                                                ])
                                              : _vm._e()
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "my-4" }, [
                              _c("p", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemManufacturer"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .name
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .legalName
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .street
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .houseNo
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .postcode
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .town
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.currentVariation.item.manufacturer
                                  .countryObject
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.countryObject.name
                                          ) +
                                          "\n                    "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .email
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer.url
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .phoneNumber
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .faxNumber
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .contactUrl
                                    )
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "my-4" }, [
                              _c("p", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemEuResponsiblePerson"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .responsibleName
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .responsibleStreet
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .responsibleHouseNo
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .responsiblePostCode
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .responsibleTown
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.currentVariation.item.manufacturer
                                  .responsibleCountryObject
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer
                                              .responsibleCountryObject.name
                                          ) +
                                          "\n                    "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .responsibleEmail
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .responsiblePhoneNo
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-0" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .responsibleContactUrl
                                    )
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]
                      )
                    ],
                    _vm._v(" "),
                    [
                      _vm.hasVariationProperties
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.filteredVariationPropertyGroups,
                              function(variationPropertyGroups, index) {
                                return _c(
                                  "div",
                                  { key: index },
                                  [
                                    _c("p", {
                                      staticClass: "m-0",
                                      attrs: { id: "range" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      variationPropertyGroups.properties,
                                      function(variationProperty, subIndex) {
                                        return variationProperty.id === 241
                                          ? _c(
                                              "div",
                                              {
                                                key: subIndex,
                                                staticClass:
                                                  "fs-range bg-gray p-3 mb-45 border-radius"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "h4 font-weight-bold mb-3"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "ohrensessel::SingleItem.NavigationRange"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      variationProperty.values
                                                        .value
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    )
                                  ],
                                  2
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e()
                    ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _vm._t("item-list-container"),
              _vm._v(" "),
              _vm._t("feedback-container")
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "btn btn-link btn-inline-block text-primary text-decoration-none py-2 pl-0"
      },
      [
        _c("span", { staticClass: "font-weight-bold show-more" }, [
          _vm._v("mehr anzeigen "),
          _c("i", {
            staticClass: "fa fa-chevron-down float-none text-dark small"
          })
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "font-weight-bold show-less" }, [
          _vm._v("weniger anzeigen "),
          _c("i", {
            staticClass: "fa fa-chevron-down float-none text-dark small"
          })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }